import Divider from '../divider'
import CollapseArrow from '../collapse-arrow'
import {ReactNode} from 'react'
import LogoAndText from '../logo-and-text'
import s from '../style.module.scss'
import TranslateButton from '../language-switch/translate-button'
import clsx from 'clsx'

interface Props {
  isMobile: boolean
  logo: ReactNode
  isActive: boolean
  toggleState: () => void
  className?: string
  footerlinks: ReactNode
  langTranslate: Record<string, string>
}

const ExpandedFooter = ({isMobile, isActive, toggleState, langTranslate, logo, footerlinks}: Props) => {
  return (
    <div className='w-full'>
      <div className={s.expand_footer_tc}>
        {isMobile && <CollapseArrow className='absolute right-0' isActive={isActive} toggleState={toggleState} />}
        <div className={clsx('flex', {'justify-center w-full': isMobile})}>
          <LogoAndText hideText={true} logo={logo} />
        </div>
        <div className={clsx('float-right', {hidden: isMobile})}>
          <TranslateButton langTranslate={langTranslate} />
        </div>
      </div>
      <div className='w-full flex justify-center mb-16'>
        <Divider solid={!isMobile} />
      </div>
      {footerlinks}
    </div>
  )
}

export default ExpandedFooter
